import { useCallback, useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaCheck, FaTag } from 'react-icons/fa';
import { Button, Card, CardBody, CardHeader, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ToastrNotifi from '../../../Utilities/ToastrNotifi';
import { useTagsData } from '../../../hooks/useTagsData';
import { useTagsPages } from '../../../hooks/useTagsPages';

function TagsModal({ show, handleClose }) {
  const [selectedTags, setSelectedTags] = useState([]);
  const [pagesView, setPagesView] = useState(false);
  const [showingResuts, setShowingResults] = useState(false);

  const { isLoading: isTagsLoading, error: tagsError, data: tagsData, isSuccess: isTagSucces, isError: isTagError } = useTagsData();
  const { isLoading: isPagesLoading, error: pageError, data: pageData, isSuccess: isPagesSuccess, isError: isPagesError, refetch, isFetching, } = useTagsPages(pagesView, selectedTags);

  if (isPagesError) {
    if (isPagesError && pageError?.response?.status === 422) {

      pageError.response.data.errors.tags.forEach(element => {
        console.error(element);
        ToastrNotifi.errorToast(element);
      });
    }
  }

  const handleTagClick = useCallback((tag) => {
    setSelectedTags((prevSelectedTags) => {
      if (prevSelectedTags.includes(tag.id)) {
        return prevSelectedTags.filter((selectedTagId) => selectedTagId !== tag.id);
      } else {
        return [...prevSelectedTags, tag.id];
      }
    });
  }, []);

  function handleSearchPages() {
    if (selectedTags.length === 0) {
      ToastrNotifi.warningToast('Please Select a Tag');
      setShowingResults(false);
      setPagesView(false);
    }
    else {
      setShowingResults(true);
      setPagesView(true);
      refetch();
    }

  }

  return (
    <Modal show={show} fullscreen={true} onHide={handleClose} className='tagModel' style={{ zIndex: 1500 }}>
      <Modal.Header closeButton>
        <Modal.Title>Tags</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <Card>
          <CardBody>

            <CardHeader>
              <h5>Select Tags</h5>
            </CardHeader>
            <div className='d-flex flex-wrap'>
              {tagsData?.map((tag) => (
                <Button
                  key={tag.id}
                  variant={selectedTags.includes(tag.id) ? 'primary' : 'outline-secondary'}
                  className={`me-2 btn-sm my-2 d-flex align-items-center ${selectedTags.includes(tag.id) ? 'bg-primary text-white' : ''}`}
                  onClick={() => handleTagClick(tag)}
                >
                  {selectedTags.includes(tag.id) ? <FaCheck className='mx-1' /> : <FaTag className='mx-1' />}{tag.name}
                </Button>

              ))}
            </div>
          </CardBody>

        </Card>

        {/* Display selected tags array */}
        <div className="mt-3">
          <strong>Selected Tags:</strong> {selectedTags.map(id => tagsData.find(tag => tag.id === id)?.name).join(', ')}
        </div>


        <div>
          <Button
            variant="outline-primary mx-2"
            onClick={handleSearchPages}
            disabled={isPagesLoading || selectedTags.length === 0} // Disable button when loading or no tags selected
          >
            {isFetching ? <> <Spinner as="span" aria-label="Loading" animation="border" size="sm" /> Searching....</> : 'Search Pages'}
          </Button>

          <Button
            variant="outline-danger"
            onClick={() => {
              handleClose();
              setPagesView(false);
            }}
          >
            Close
          </Button>
        </div>

        {showingResuts ? (
          <div className='mt-3'>
            {isPagesSuccess ? (
              <>
                <div className='h6'>Search Results:</div>
                <ul class="list-group list-group-flush">
                  {pageData?.pages?.length > 0 ? (
                    pageData.pages.map((page) => (
                      <li key={page.id} onClick={() => {
                        handleClose();   // Close the modal or do something
                        setPagesView(true);  // Set pagesView to true
                      }} className="list-group-item">
                        <Link to={`/page/content/${page.id}/${page.slug}`}>
                          {page.title}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <div>No pages found</div>  // Handle case when there are no pages
                  )}
                </ul>

                {isPagesError && pageError?.response?.status === 422 && (
                  <div className="error-message">
                    {pageError.response.data.errors.tags?.map((msg, index) => (
                      <p key={index}>{msg}</p>
                    ))}
                  </div>
                )}
              </>
            ) : (
              null
            )}
          </div>
        ) : (
          null
        )}


      </Modal.Body>
    </Modal>
  );
}

export default TagsModal;
